import React from 'react';
import { Tooltip } from 'reactstrap';
import PropTypes from 'prop-types';

const propTypes = {
    autoFocus: PropTypes.bool,       // Focus on input on load
    className: PropTypes.string,     // Custom class name to add to input container
    disabled: PropTypes.bool,        // Disable input
    id: PropTypes.string,            // Input id
    name: PropTypes.string,          // Input name
    onChange: PropTypes.func,        // Invoked every time the user changes the input's value.
    placeholder: PropTypes.string,   // Input placeholder text
    required: PropTypes.bool,        // Set to true so input empty validation check will trigger on blur and keypress
    tooltipID: PropTypes.string,     // Tooltip id which is required to display tooltip message
    tooltipMsg: PropTypes.string,    // Tooltip message
    type: PropTypes.string,          // Input type
    value: PropTypes.bool            // Input value
};
// Basic setup of checkmark switch. If need to handle anything will need to add it.

class ToggleSwitch extends React.Component {
    constructor(props) {
        super(props);
        this.toggleToolTip = this.toggleToolTip.bind(this);
        this.state = {
            tooltipOpen: false
        };
    }

    toggleToolTip() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    onChange(checked) {
        this.props.onChange(checked);
    }

    render() {

        const { name, id, autoFocus, disabled, placeholder, value, required, type, className, tooltipID, tooltipMsg } = this.props;
        let { checked } = this.props;
        if (!checked) {
            checked = false;
        }
        var dynamicClass = className ? className : '';

        return (
            <div className="switch-group">
                <label>
                    <div className="switch-label">{placeholder}</div>
                    <div className={"switch" + (disabled ? " disabled-style" : "")}>

                            <input type={type ? type : "checkbox"}
                                value={value}
                                className={dynamicClass}
                                required={required}
                                name={name}
                                id={id || name}
                                disabled={disabled}
                                autoFocus={autoFocus}
                                checked={checked}
                                onChange={(e) => this.onChange(!checked)}
                            />

                        <span className="slider round" />
                    </div>
                </label>
                {(tooltipID && tooltipMsg) && <div className="input-icon-append ">
                    <span className="icon-info" id={tooltipID} />
                    <Tooltip placement="top" isOpen={this.state.tooltipOpen} autohide={false} target={tooltipID} toggle={this.toggleToolTip}>
                        {tooltipMsg}
                    </Tooltip>
                </div>}
            </div>);
    }
}

ToggleSwitch.propTypes = propTypes;

export default ToggleSwitch;
